import { CSSProperties, type KeyboardEvent, forwardRef } from "react"

import { Option } from "$/models/option"

import { buildCssClassName } from "@/3514/utils"
import { emptyCallback } from "@/shared/types/functions"

import "./styles.scss"

type Props = {
    items: Option[]
    className?: string
    styles?: CSSProperties
    onClick: (item: Option) => void
}

const ContextMenu = forwardRef<HTMLUListElement, Props>((props, ref) => {
    const { items, className, styles, onClick } = props

    return (
        <ul role="menu" className={buildCssClassName("context-menu", className)} ref={ref} style={styles}>
            {items.map(item => (
                <li
                    role="menuitem"
                    tabIndex={0}
                    onClick={(): void => onClick(item)}
                    onKeyDown={(e: KeyboardEvent): void =>
                        e.key === "Enter" || e.key === "Space" ? onClick(item) : emptyCallback()
                    }
                    key={item?.id ?? item.label}
                >
                    {item.label}
                </li>
            ))}
        </ul>
    )
})

ContextMenu.displayName = "ContextMenu"

export default ContextMenu
